export const GuestLinkStatus = {
    ACTIVE: 'active',
    EXPIRED: 'expired',
    DEACTIVATED: 'deactivated',
    PENDING: 'pending',
    INVALIDATED: 'invalidated',
};
